import { supabase } from "@/integrations/supabase/client";

export type EntityType = "Candidates" | "Companies" | "Jobs" | "Matches" | "Lists" | "Tasks" | "Workforce";
export type FieldType = "text" | "number" | "boolean" | "dropdown";

export interface CustomField {
  name: string;
  type: FieldType;
  options?: string[];
}

export type CustomFieldsJSON = Record<EntityType, CustomField[]>;

export async function fetchCustomFields(organizationId: string): Promise<CustomFieldsJSON> {
  const { data, error } = await supabase
    .from("custom_fields")
    .select("custom_fields")
    .eq("organization_id", organizationId)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return (data?.custom_fields ?? {
    Candidates: [],
    Companies: [],
    Jobs: [],
    Matches: [],
    Lists: [],
    Tasks: [],
    Workforce: [],
  }) as CustomFieldsJSON;
}

export async function upsertCustomFields(organizationId: string, customFields: CustomFieldsJSON) {
  // Ensure organization_id is a UUID string
  const { error } = await supabase
    .from("custom_fields")
    .upsert([
      {
        organization_id: organizationId,
        custom_fields: customFields,
      },
    ], { onConflict: "organization_id" });
  if (error) throw error;
} 